import React, { useEffect, useState } from "react";
import { Modal, ModalBody, Button, Textarea } from "@windmill/react-ui";

const ConfirmAgentModal = ({ isOpen, onClose, onConfirm, status, nextStatus, requireRemark }) => {
  const [remarks, setRemarks] = useState("");
  const [goStatus, setGoStatus] = useState();
  const [initialStatus, setInitialStatus] = useState();

  useEffect(() => {
  setInitialStatus(status);

  if (isOpen) {
    if (status === "0" || status === "2") {
      setGoStatus("1");
    } else {
      setGoStatus(undefined);
    }
  } else {
    setGoStatus(undefined);
    setRemarks("");
  }
}, [isOpen, status]);

  const handleRemarkChange = (e) => setRemarks(e.target.value);
  const handleStatusChange = (e) => setGoStatus(e.target.value);

  const handleConfirm = () => {
    onConfirm(remarks, goStatus);
    onClose();
    setRemarks("");
    setGoStatus(undefined);
  };

  const handleClose = () => {
    setRemarks("");
    setGoStatus(undefined);
    onClose();
  };

  // Determine options based on current status
  let statusOptions = [];

  if (status === "1") {
    // Active: allow Inactive or Block
    statusOptions = [
      { value: "0", label: "Inactive" },
      { value: "2", label: "Block" },
    ];
  } else if (status === "0") {
    // Inactive: only offer Active
    statusOptions = [
      { value: "1", label: "Active" }
    ];
  } else if (status === "2") {
    // Blocked: only offer Unblock
    statusOptions = [
      { value: "1", label: "Unblock" }
    ];
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalBody>
        <p className="text-lg font-semibold mb-2">Status Update</p>

        <div className="my-4 flex space-x-4">
          {statusOptions.map((opt) => (
            <label key={opt.value} className="flex items-center space-x-2">
              <input
                type="radio"
                name="status"
                value={opt.value}
                checked={goStatus === opt.value}
                onChange={handleStatusChange}
              />
              <span>{opt.label}</span>
            </label>
          ))}
        </div>

        <div>
          {requireRemark && (
          <>
          <p className="text-lg font-medium mb-2">Enter remark</p>
          <Textarea
            name="agent_remark"
            value={remarks}
            placeholder="Minimum 10 characters"
            style={{
              minHeight: "100px",
              maxHeight: "300px",
              scrollbarWidth: "thin",
            }}
            onChange={handleRemarkChange}
          />
          </>
          )}
        </div>

        <div className="flex justify-end mt-4 space-x-2">
          <Button
            layout="outline"
            onClick={handleClose}
            className="hover:bg-white hover:border-gray-50"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={
              (requireRemark && remarks.trim().length < 10) ||
              goStatus === initialStatus ||
              goStatus === undefined
            }
          >
            Confirm
          </Button>
        </div>
      </ModalBody>
    </Modal>
  ); 
};

export default ConfirmAgentModal;
